export * from './single-apartment';
export * from './single-apartment.props';
